export const TEXT = 'text';
export const CHANNEL_IDS = 'channelIds';
export const RECIPIENT_OWNER_PROPERTIES = 'recipientOwnerProperties';
export const SLACK_CHANNEL_IDS = 'slackChannelIds';
export const SLACK_USER_IDS = 'slackUserIds';
export const ACTION_TYPE = 'actionType';
export const OBJECT_PROPERTIES = 'objectProperties';